<template>
	<div class="home">
		<div class="ml">
			<Button :type="type==1?'primary':''" class="" @click="xuanze(1)">商品销售统计</Button>
			<Button :type="type==2?'primary':''" @click="xuanze(2)">数据分析</Button>
		</div>
		<div class="aa">
			<router-view />
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	export default {
		
		data() {
			return {
				type:1,
			}
		},
		methods:{
			xuanze(type){
				let _this=this
				if(type!=_this.type){
					_this.type=type
					switch (type){
						case 1:
						    this.$router.push('/alliancetj1')
							break;
						case 2:
						    this.$router.push('/alliancetj2')
							break;
						default:
							break;
					}
				}
			}
		},
		created() {
			
		}
		
	}
</script>
<style scoped="scoped">
	

	.aa{
		background-color: #F6F6F6;
		border-radius: 15px;
		margin: 20px;
		padding: 20px;
	}
</style>


// WEBPACK FOOTER //
// src/components/home/alliance/home.vue